//Parroquia Distrito capital
const munDistrito = [
  'Altagracia',
  'Antímano',
  'Candelaria',
  'Caricuao',
  'Catedral',
  'Coche',
  'El Junquito',
  'EL Paraíso',
  'El Recreo',
  'El Valle',
  'La Pastora',
  'La Vega',
  'Macarao',
  'San Agustín',
  'San Bernardino',
  'San José',
  'San Juan',
  'San Pedro',
  'Santa Rosalía',
  'Santa Teresa',
  'Sucre',
  '23 de Enero',
];

export const esDistrito = [
  {
    municipio: 'Distrito Capital',
    parroquias: munDistrito,
  },
];
